import {createContext, useState} from "react";

export const ConfigContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyConfig = {
        application: "",
        profile: "",
        label: "",
        key: "",
        value: "",
        enabled: true,
        description: ""
    }

    const [config, setConfig] = useState(emptyConfig);
    const [configs, setConfigs] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [configDialog, setConfigDialog] = useState(false);

    const resetConfig = () => {
        setConfig(emptyConfig);
    };

    // Make the context object:
    const configContext = {
        config,
        resetConfig,
        setConfig,
        configs,
        setConfigs,
        submitted,
        setSubmitted,
        configDialog,
        setConfigDialog,
    };

    // pass the value in provider and return
    return <ConfigContext.Provider value={configContext}>{children}</ConfigContext.Provider>;
}

export const {Consumer} = ConfigContext;
